<template>
  <div>
    
    <div class="main-sessions sec-pt sec-mb" id="sessions">
      <div class="container-fluid">
        <div class="row">

        <div class="col-md-6">
          <div class="session-card">
            <img v-if="row.image1" :src="row.image1" :alt="row.title1">
            <div class="content">
                <p v-html="row.title1" :style="'color:'+row.color1+' !important;white-space:break-spaces;font-family: dubai-b !important'"></p>
                <router-link v-if="row.button1" :to="row.redirect1" class="btn-primary btn--black" 
                  style='float:left'>
                  <div class="d-flex align-items-center">
                    {{ row.button1 }} 
                    <span class="icon-arrow-right ml-2"></span>
                  </div>
                </router-link>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="session-card-50">
            <img v-if="row.image2" :src="row.image2" :alt="row.title2">
            <div class="content">
                <p v-html="row.title2" :style="'color:'+row.color2+' !important;white-space:break-spaces;font-family: dubai-b !important'"></p>
                <router-link v-if="row.button2" :to="row.redirect2" class="btn-primary iaa-read-more-btn btn-white" 
                  style="float:left">
                  {{ row.button2 }} <span class="icon-arrow-right ml-2"></span>
                </router-link>
            </div>
          </div>
          <div class="session-card-50-lined">
            <img v-if="row.image3" :src="row.image3" :alt="row.title3">
            <div class="content"  style="min-height: 0 !important">
                <p v-html="row.title3" :style="'color:'+row.color3+' !important;white-space:break-spaces;font-family: dubai-b !important'"></p>
                <router-link v-if="row.button3" :to="row.redirect3" class="btn-primary d-inline-block float-right btn-white"
                    style="margin-top: 30px">
                  <div class="d-flex align-items-center">
                    {{ row.button3 }} <span class="icon-arrow-right ml-2"></span>
                  </div>
                </router-link>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.iaa-read-more-btn {
  display: flex;
  align-items: center;
}
.icon-arrow-right {
  font-weight: bold;
}
</style>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
